import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

import { CookieService } from 'ngx-cookie-service';
import { AuthenticationService } from './authentication.service';
 
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class NotificationsService {

  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient, private router: Router, private authenticationService: AuthenticationService, private cookieService: CookieService) {

  }

  getUserNotifications (userId) {
    let httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'Token': this.cookieService.get('perchedToken') } ) };
    return this.http.get(this.baseUrl + '/users/' + userId + '/notifications',  httpOptions);
  }

  getAllUserNotifications (userId) {
    let httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'Token': this.cookieService.get('perchedToken') } ) };
    return this.http.get(this.baseUrl + '/users/' + userId + '/notifications/all',  httpOptions);
  }

  deleteNotification (notificationId) {
    let httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'Token': this.cookieService.get('perchedToken') } ) };
    return this.http.delete(this.baseUrl + '/notifications/' + notificationId, httpOptions);
  }

  acknowledgeNotification (notificationId) {
    let httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'Token': this.cookieService.get('perchedToken') } ) };
    return this.http.get(this.baseUrl + '/notifications/' + notificationId + '/acknowledge', httpOptions);
  }

}


// WEBPACK FOOTER //
// /Users/cullenkirkpatrick/Documents/Goals/goal-project/src/app/services/notifications.service.ts